import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { compressImgFile, ImagesOptions } from '../helper';
import { MediaKeys } from '../views/offers/utils';

export const useImageUploadWithPreview = ({ form, fieldName, acceptedImageFormats, mediaKey }) => {
  const { setValue, trigger } = form; 
  // For storing the preview of the uploaded image
  const [preview, setPreview] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [shouldDeleteExistingImage, setShouldDeleteExistingImage] = useState(false);
  
  const onDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (!file) return;
    setIsUploading(true);
    let compressedImageBlob;
    if (mediaKey === MediaKeys.MEDIA || mediaKey === MediaKeys.BANNER_LOGO) {
      compressedImageBlob = await compressImgFile(
        file,
        ImagesOptions(3)[mediaKey].DIMENSION.WIDTH,
        ImagesOptions(3)[mediaKey].DIMENSION.HEIGHT
      );
    } else {
      compressedImageBlob = await compressImgFile(file);
    }
  
    setPreview({
      image: compressedImageBlob,
      previewURL: URL.createObjectURL(compressedImageBlob),
      fileName: file.name,
    });
    setValue(fieldName, { blob: compressedImageBlob, fileName: file.name });
    setIsUploading(false);
    await trigger(fieldName);
  }, [fieldName, setValue]);

  const removeImage = async () => {
    setPreview(null);
    if (shouldDeleteExistingImage) {
      setValue(fieldName, '');
    } else {
      setValue(fieldName, null);
    }
    await trigger(fieldName);
  };

  const handleDeleteExistingImage = async () => {
    setShouldDeleteExistingImage(true);
    setValue(fieldName, '');
    await trigger(fieldName);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/*': acceptedImageFormats
    },
    multiple: false,
    disabled: isUploading
  });

  return {
    getRootProps,
    getInputProps,
    preview,
    removeImage,
    shouldDeleteExistingImage,
    handleDeleteExistingImage
  };
};
